import { Injectable } from '@angular/core';
import { StrapiCollectionEntityByCityApiService } from '@core/data-access';
import { PagesEntityStrapi } from '@seo/const';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class PagesApiService extends StrapiCollectionEntityByCityApiService<PagesEntityStrapi> {
  constructor() {
    super('pages', 'citiesIncluded', 'citiesExcluded');
  }

  loadPage(urlOrLabel: string, baseStoreCode: string): Observable<PagesEntityStrapi | null> {
    return this.getListByCity(
      {
        filters: { urlOrLabel: { $eq: urlOrLabel } },
        pagination: { page: 1, pageSize: 1 },
      },
      baseStoreCode,
    ).pipe(map((pages) => pages?.[0] || null));
  }
}
